module.exports = __webpack_public_path__ + "static/editor_light_dark-a9b6b34a9a7413781f32537b8668e282.png";